import { ISelectOption } from '@principle-theorem/shared';
import { IAccEmployment, IAccInjury } from '../../acc/claim/acc-claim';
import { AccOccupationCode } from '../../acc/acc-code-tables';

type AccWorkInjury = Pick<IAccInjury, 'workInjury'>;

interface IAccOccupationCode {
  occupationCode?: ISelectOption<AccOccupationCode>;
}

export type IAccEmploymentForm = IAccEmployment &
  AccWorkInjury &
  IAccOccupationCode;
